import { styled } from '@mui/material';

export const CoordenadorContainer = styled('div')({
  minHeight: '75px',
  border: '0.25px solid #A4A2A2',
  padding: '15px',
  borderRadius: '5px',
  marginBottom: '2em',
  marginTop: '1em',
});
